module.exports = __webpack_public_path__ + "images/fa-discover_ty.jpg";